<template>
    <div class="editable-container">
        <el-button v-if="showAdd" type="primary" @click="addRow">添加</el-button>
        <el-table :data="value" border :height="height" style="width: 100%" :header-cell-style="headerStyle" stripe>
            <el-table-column type="index" label="序号" align="center">

            </el-table-column>
            <el-table-column :prop="item.prop" :label="item.label" :width="item.width" v-for="item in header"
                :key="item.prop" align="center">
                <template slot-scope="scope">
                    <ElInputTrim v-model="scope.row[item.prop]" v-if="item.type === 'input' && (scope.row.isEdit || canEdit)"
                        @input="handleInput" clearable :valueType="item.valueType"></ElInputTrim>
                    <el-select v-model="scope.row[item.prop]" placeholder="请选择" clearable
                        v-else-if="item.type === 'select' && (scope.row.isEdit || canEdit)">
                        <el-option v-for="i in item.data" :key="i.value" :label="i.label" :value="i.value">
                        </el-option>
                    </el-select>
                    <el-date-picker v-else-if="item.type === 'date' && (scope.row.isEdit || canEdit)" v-model="scope.row[item.prop]"
                        clearable :format="dateTypeMap[item.dateType]" :value-format="dateTypeMap[item.dateType]"
                        :type="item.dateType" placeholder="选择日期">
                    </el-date-picker>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="address" label="操作" v-if="showEdit || showDel" align="center">
                <template slot-scope="scope">
                    <el-button v-if="showEdit" :type="scope.row.isEdit ? 'success' : 'primary'" @click="editRow(scope.row)">
                        {{ scope.row.isEdit ? '确定' : '修改' }}
                    </el-button>
                    <el-button v-if="showDel" type="danger" @click="delRow(scope)">移除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import ElInputTrim from '@/components/ElInputTrim/index.vue';
export default {
    name: 'ElFieldInput',
    components: {
        ElInputTrim
    },
    props: {
        value: {
            type: Array,
        },
        header: {
            type: Array,
            default: () => [],
        },
        headerStyle: {
            type: Object,
            default: () => {} // 'input', 'blur', or 'manual'
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        showEdit: {
            type: Boolean,
            default: false
        },
        showDel: {
            type: Boolean,
            default: false
        },
        canEdit: {
            type: Boolean,
        },
        height:{

        }
    },
    data() {
        return {
            innerValue: this.value,
            errorMsg: '',
            dateTypeMap: {
                date: 'yyyy-MM-dd',
                month: 'yyyy-MM',
                year: 'yyyy',
            }
        };
    },
    created(){
    },
    methods: {
        generateRandomString(length) {
            return Math.random().toString(36).substring(2, length + 2);
        },
        editRow(row){
            if (row.isEdit){
                this.$set(row, 'isEdit', false);
            }else{
                this.$set(row, 'isEdit', true);
            }
        },
        delRow(row){
            this.$emit('delRow', row)
        },
        addRow(){
            const obj = {
                isEdit: true
            };
            for(let i = 0; i < this.header.length; i++){
                obj[this.header[i]['prop']] = '';
            }
            this.value.push(obj);
        },
        // 当 input 事件触发时更新数据
        handleInput(row) {
            this.$emit('input', [...this.value]); // 触发父组件数据更新
        },
        // 当 change 事件触发时更新数据
        handleChange(row) {
            this.$emit('input', [...this.value]); // 触发父组件数据更新
        },
    }
};
</script>

<style lang="scss" scoped>
.is-error input,
.is-error .el-input__inner,
.is-error .el-date-editor,
.is-error .el-select {
    border-color: #f56c6c !important;
}

.error-msg {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 4px;
}
/deep/ .el-table .cell {
    padding: 0;
    white-space: break-spaces;
}
/deep/ .el-table .el-date-editor {
    border: none;
    box-shadow: none;
    margin: 0;
    /* 防止外部影响 */
}
</style>
